import styles from "./FlowCards.module.scss";

type FlowCardsProps = {
  items: string[];
};

const ITEMS_PER_ROW = 3;

const chunk = <T,>(arr: T[], size: number): T[][] => {
  const result: T[][] = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
};

export const FlowCards = ({ items }: FlowCardsProps) => {
  if (items.length === 0) {
    return <p className={styles["empty"]}>業務フローデータがありません</p>;
  }

  const rows = chunk(items, ITEMS_PER_ROW);

  return (
    <div className={styles["container"]}>
      {rows.map((row, rowIndex) => (
        <div key={row.join("-")} className={styles["row"]} data-testid="flow-row">
          {row.map((item, itemIndex) => {
            const currentIndex = rowIndex * ITEMS_PER_ROW + itemIndex;
            const isLast = currentIndex === items.length - 1;
            const isLastInRow = itemIndex === row.length - 1;

            return (
              <div key={`flow-${currentIndex}-${item}`} className={styles["item"]}>
                <div className={`${styles["card"]} ${isLast ? styles["cardLast"] : ""}`}>
                  <span className={`${styles["badge"]} ${isLast ? styles["badgeLast"] : ""}`}>
                    {currentIndex + 1}
                  </span>
                  <span className={styles["cardTitle"]}>{item}</span>
                </div>
                {!isLastInRow && <span className={styles["arrow"]}>▶</span>}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};
